module.exports = __webpack_public_path__ + "static/media/shenque.4004c5a1.mp3";